import React, { useEffect, useState } from 'react';
import { Drawer, List, Checkbox, Button } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';

const ScreenDrawer = ({ open, onClose, onSubmit, initialScreens = [] }) => {
  const { screenList } = useSelector(
    (state) => ({ screenList: state.screens.list }),
    shallowEqual
  );

  const [checkedKeys, setCheckedKeys] = useState([]);

  useEffect(() => {
    if (open) {
      setCheckedKeys(initialScreens);
    }
  }, [open, initialScreens]);

  const allIds = (screenList || []).map((s) => s._id);
  const allChecked = allIds.length > 0 && checkedKeys.length === allIds.length;
  const indeterminate =
    checkedKeys.length > 0 && checkedKeys.length < allIds.length;

  const toggleAll = (checked) =>
    setCheckedKeys(checked ? allIds : []);

  const toggleOne = (id, checked) =>
    setCheckedKeys((prev) =>
      checked
        ? [...new Set([...prev, id])]
        : prev.filter((k) => k !== id)
    );

  const handleSubmit = () => {
    const selected = (screenList || []).filter((s) =>
      checkedKeys.includes(s._id)
    );
    onSubmit(selected);
    onClose();
  };

  return (
    <Drawer
      title="Add Screen Allocation"
      placement="right"
      onClose={onClose}
      open={open}
      width={420}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      }
    >
      <Checkbox
        indeterminate={indeterminate}
        checked={allChecked}
        onChange={(e) => toggleAll(e.target.checked)}
        style={{ marginBottom: 12 }}
      >
        Select All Screens
      </Checkbox>
      <List
        bordered
        dataSource={screenList || []}
        locale={{ emptyText: 'No screens available' }}
        renderItem={(item) => (
          <List.Item key={item._id}>
            <Checkbox
              checked={checkedKeys.includes(item._id)}
              onChange={(e) => toggleOne(item._id, e.target.checked)}
            >
              <strong>{item.name}</strong>
              {item.description && (
                <div>
                  <small>{item.description}</small>
                </div>
              )}
            </Checkbox>
          </List.Item>
        )}
      />
    </Drawer>
  );
};

export default ScreenDrawer;
